import React from "react";

const Header = () => <h1 className="apptitle text-center">Bank Balance App</h1>;

export default Header;
